import { useNavigate, useLocation } from "react-router-dom";

export const NavItems = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id: string) => {
    if (location.pathname !== '/landing') {
      navigate('/landing');
      setTimeout(() => {
        const element = document.getElementById(id);
        element?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      const element = document.getElementById(id);
      element?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleSupport = () => {
    navigate('/support');
  };

  const handlePricing = () => {
    navigate('/pricing');
  };

  return (
    <>
      <button 
        onClick={() => scrollToSection('features')} 
        className="text-sm hover:text-primary transition-colors py-3 px-4 w-full text-left md:w-auto md:px-0"
      >
        Features
      </button>
      <button 
        onClick={handlePricing}
        className="text-sm hover:text-primary transition-colors py-3 px-4 w-full text-left md:w-auto md:px-0"
      >
        Pricing
      </button>
      <button 
        onClick={() => scrollToSection('testimonials')} 
        className="text-sm hover:text-primary transition-colors py-3 px-4 w-full text-left md:w-auto md:px-0"
      >
        Testimonials
      </button>
      <button 
        onClick={handleSupport}
        className="text-sm hover:text-primary transition-colors py-3 px-4 w-full text-left md:w-auto md:px-0"
      >
        Support
      </button>
    </>
  );
};